import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import { useRole } from '../App';

export default function Navbar() {
  const location = useLocation();
  const { role, userRecord } = useRole();
  const [menuOpen, setMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  const adminLinks = [
    { to: '/', label: 'Dashboard' },
    { to: '/calculator', label: 'Calculator', match: '/calculator' },
    { to: '/packages', label: 'Packages' },
    { to: '/reports', label: 'Reports' },
    { to: '/admin', label: 'Admin' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-neutral-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://static.wixstatic.com/media/cf458d_f7329a8f179a4571a1951c4ed9431604~mv2.png" alt="NEG" className="h-6 sm:h-7" />
            <span className="font-display font-bold text-brand-gold text-sm sm:text-base tracking-wider">Beverage Collective</span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden sm:flex items-center gap-2">
            {role === 'admin' && adminLinks.map(link => (
              <Link key={link.to} to={link.to}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${(link.match ? location.pathname.startsWith(link.match) : isActive(link.to)) ? 'bg-neutral-800 text-brand-gold' : 'text-neutral-400 hover:text-white'}`}>
                {link.label}
              </Link>
            ))}
            {role === 'supplier' && <span className="text-[10px] px-2 py-1 rounded bg-blue-500/15 text-blue-400 font-medium">Supplier</span>}
            {role === 'operator' && <span className="text-[10px] px-2 py-1 rounded bg-emerald-500/15 text-emerald-400 font-medium">Operator</span>}
            <span className="text-[10px] text-neutral-600">{userRecord?.company_name || userRecord?.email}</span>
            <button onClick={() => supabase.auth.signOut()} className="text-neutral-600 hover:text-neutral-400 text-xs ml-1">Sign Out</button>
          </div>

          {/* Mobile hamburger */}
          <div className="flex sm:hidden items-center gap-2">
            {role && <span className={`text-[9px] px-2 py-0.5 rounded font-medium ${role === 'admin' ? 'bg-brand-gold/15 text-brand-gold' : role === 'supplier' ? 'bg-blue-500/15 text-blue-400' : 'bg-emerald-500/15 text-emerald-400'}`}>{role}</span>}
            <button onClick={() => setMenuOpen(!menuOpen)} className="w-9 h-9 rounded-lg flex items-center justify-center text-neutral-400 hover:text-white">
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="sm:hidden bg-black/95 border-t border-neutral-800/50 px-4 py-3 space-y-1">
          {role === 'admin' && adminLinks.map(link => (
            <Link key={link.to} to={link.to} onClick={() => setMenuOpen(false)}
              className={`block px-4 py-3 rounded-lg text-sm font-medium ${(link.match ? location.pathname.startsWith(link.match) : isActive(link.to)) ? 'bg-neutral-800 text-brand-gold' : 'text-neutral-400'}`}>
              {link.label}
            </Link>
          ))}
          <button onClick={() => { supabase.auth.signOut(); setMenuOpen(false); }}
            className="block w-full text-left px-4 py-3 rounded-lg text-sm text-neutral-600">Sign Out</button>
        </div>
      )}
    </nav>
  );
}
